import { IOfferCard } from '../../../../types';
import { isDailyRent } from '../../utils';

export const prepareDailyRating = ({ dailyrent, category }: IOfferCard) => {
  if (!isDailyRent(category)) {
    return;
  }

  return dailyrent?.rating;
};
